module.exports = __webpack_public_path__ + "static/media/26_tn.0dea675a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/thumbnails/26_tn.jpg
// module id = 240
// module chunks = 0